import { Demographic } from 'api/actions/analyze/companyFilters/companyFiltersActions.types'
import { Survey } from 'sagas/actions/analyze/shared.types'

import { SelectedFilters } from './../index'

export type DataRepresentationProps = {
    demographic?: Demographic
    selectedFiltersPayload?: SelectedFilters
    selectedSurvey?: Survey | null
    selectedTab: string
}

export enum RepresentationView {
    Chart = 'chart',
    Table = 'table',
    ChartTable = 'chart-table',
}
